import React, { useState, useEffect } from 'react';
import { ShippingCache, checkDeliveryTime, fetchNextWorkDay } from '../utils';

const ShippingCard = ({ title, schedule, type }) => {
    const [nextDay, setNextDay] = useState(null);

    useEffect(() => {
        const checkNextWorkDay = async () => {
            /* console.log('Verificando próximo dia:', {
                schedule,
                isAfterDelivery: checkDeliveryTime(schedule)
            }); */

            const isAfterDelivery = checkDeliveryTime(schedule);
            if (!isAfterDelivery) return;

            if (!ShippingCache.wasCheckedToday()) {
                try {
                    const nextWorkDay = await fetchNextWorkDay(null, null, type);
                    if (nextWorkDay) {
                        ShippingCache.saveCheck(nextWorkDay);
                        setNextDay(nextWorkDay.name);
                    }
                } catch (error) {
                    console.error('Erro ao verificar próximo dia útil:', error);
                }
            } else {
                const cached = ShippingCache.getData();
                if (cached?.nextWorkDay) {
                    setNextDay(cached.nextWorkDay.name);
                }
            }
        };

        // Verificar à meia-noite
        const checkMidnight = () => {
            const now = new Date();
            if (now.getHours() === 0 && now.getMinutes() === 0) {
                const cached = ShippingCache.getData();
                if (cached?.nextWorkDay?.type === 'tomorrow') {
                    setNextDay(null);
                    ShippingCache.clear();
                }
            }
        };

        checkNextWorkDay();
        const interval = setInterval(checkMidnight, 60000); // Verifica a cada minuto

        return () => clearInterval(interval);
    }, [schedule, type]); // Adicionei type nas dependências

    if (!schedule?.cutoffSales) return null;

    const getBackgroundColor = () => {
        const now = new Date();
        const currentDay = now.getDay();

        if (currentDay === 0 || currentDay === 6) return '#FFE600';

        const [salesHours, salesMinutes] = schedule.cutoffSales.split(':');
        const salesTime = new Date();
        salesTime.setHours(parseInt(salesHours), parseInt(salesMinutes), 0);

        const oneHourBeforeSales = new Date(salesTime);
        oneHourBeforeSales.setHours(salesTime.getHours() - 1);

        if (schedule.deliveryTime) {
            const [deliveryHours, deliveryMinutes] = schedule.deliveryTime.split(':');
            const deliveryTime = new Date();
            deliveryTime.setHours(parseInt(deliveryHours), parseInt(deliveryMinutes), 0);
            const oneHourBeforeDelivery = new Date(deliveryTime);
            oneHourBeforeDelivery.setHours(deliveryTime.getHours() - 1);

            if (now > deliveryTime) return '#FFE600';
            else if (now >= oneHourBeforeDelivery) return '#ff0000';
            else if (now > salesTime) return '#ff8000';
        } else {
            // FLEX: alerta baseado no cutoffSales
            if (now > salesTime) return '#FFE600';
            else if (now >= oneHourBeforeSales) return '#ff0000';
        }

        return '#FFE600';
    };

    return (
        <div style={{
            backgroundColor: getBackgroundColor(),
            color: '#2D3277',
            padding: '8px 12px',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            height: '32px'
        }}>
            <span style={{
                fontWeight: 'bold',
                fontSize: '0.9em',
                borderRight: '1px solid #2D3277',
                paddingRight: '12px',
                whiteSpace: 'nowrap'
            }}>
                {title}
                {nextDay && (
                    <span style={{
                        marginLeft: '8px',
                        fontSize: '0.8em'
                    }}>
                        ({nextDay})
                    </span>
                )}
            </span>

            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                fontSize: '0.9em',
                whiteSpace: 'nowrap'
            }}>
                <span>Vendas até: {schedule.cutoffSales}</span>
                {schedule.deliveryTime && <span>Entrega até: {schedule.deliveryTime}</span>}
            </div>
        </div>
    );
};



export default ShippingCard;